<template>
  <Container type="card-full">
    <div slot="header"  v-if="type === 1 || type === 2" >
      <el-button @click="fbgg" v-if="+project.projectstatus < 40"  :loading="btnLoading">发布结果公告</el-button>
      <el-button @click="lodopPrint" :loading="btnLoading">打印</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
      <span class="status"  v-if="+project.projectstatus >= 40">已发布</span>
    </div>
    <!-- <div slot="header" >
      <el-button @click="lodopPrint" :loading="btnLoading">打印</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
    <div id="px" style="width:800px;height:400px;padding:10px;" ref="px">
      <table style="width: 100%">
        <tr>
          <th colspan="2" style="font-size: 20px; color: red" align="center" >{{project.projectname}}  结果公告</th>
        </tr>
        <tr>
          <td  align="left">信息来源:</td>
          <td  align="right">采购人:{{project.pcomname}}</td>
          <td  align="right">发布日期:{{project.projecttime | newDate}}</td>
        </tr>
        <tr>
          <td  align="left">发布机构:{{project.acomname}}</td>
          <td  align="right">代理联系人:{{project.ausername}}</td>
          <td  align="right">采购联系人:{{project.pusername}}</td>
        </tr>
      </table>
      <div>
        南方招标与采购平台，于{{project.prsbjbegtime | newDate}}至{{project.prsbjendtime | newDate}}
        就{{project.projectname}}(项目编号：{{project.projectcode}})采用网上竞价方式进行采购。
        现就本次采购的竞价结果公告如下：
      </div>
      <div>一.项目编号：{{project.projectcode}}</div>
      <div>二.项目名称：{{project.projectname}}</div>
      <div>三.项目最高限价：人民币{{project.projecttopamt}}元</div>
      <div>四.采购时间：{{project.projecttime | newDate}}</div>
      <div>五.报价汇总表</div>
      <table  border="1" cellspacing="0" cellpadding="0" width="100%">
        <tr>
          <td  align="center">序号</td>
          <td  align="center">报价单位</td>
          <td  align="center">总报价</td>
          <td  align="center">报价时间</td>
          <td  align="center">备注</td>
        </tr>
        <tr v-for="(psu,index) in project.psuList" :key="psu.psuid">
          <td  align="center">{{index+1}}</td>
          <td align="center">{{psu.comname}}</td>
          <td  align="center">{{psu.psuamt}}元</td>
          <td  align="center">{{psu.psutime | newDate}}</td>
          <td  align="center">{{psu.psuremark}}</td>
        </tr>
      </table>
      <div>六.成交信息</div>
      <table  border="1" cellspacing="0" cellpadding="0" width="100%">
        <tr>
          <td  align="center">序号</td>
          <td  align="center">成交单位</td>
          <td  align="center">成交金额</td>
          <td  align="center">报价时间</td>
        </tr>
        <tr v-for="(psu,index) in project.psuList" :key="psu.psuid" v-if="psu.psubidflg ===1">
          <td  align="center">{{index+1}}</td>
          <td align="center">{{psu.comname}}</td>
          <td  align="center">{{psu.psuamt}}元</td>
          <td  align="center">{{psu.psutime  | newDate}}</td>
        </tr>
      </table>
      <div>七.联系事项：
        <div>采购人：{{project.pcomname}}</div>
        <div>联系人：{{project.pusername}}</div>
        <div>联系电话：{{project.projectptel}}</div>
      </div>
      <div>八.采购人：
        <div>代理单位：{{project.acomname}}</div>
        <div>联系人：{{project.ausername}}</div>
        <div>联系电话：{{project.projectatel}}</div>
      </div>
      <div>
        <table style="width: 100%">
          <tr>
            <td  align="left">责任声明:</td>
            <td  align="left">本页面提供的内容是由{{project.pcomname}}委托{{project.acomname}}发布的，{{project.comname}}对本项目的竞价结果负相关责任且拥有最终解释权。</td>
          </tr>
        </table>
      </div>
    </div> -->
    <div class="notice-content" id="px" ref="px">
       <div class="title">
        {{project.projectname}}结果公告
      </div>
       <div class="desc">
        信息来源: 采购人:{{project.pcomfullname}} 发布日期:{{project.projecttime | newDate}} 发布机构:{{project.comfullname}}
                代理联系人:{{project.ausername}}
      </div>
      <div class="line"></div>
      <div class="line1"></div>
      <div class="text">
        南方招标与采购平台，于{{project.prsbjbegtime | newDate}}至{{project.prsbjendtime | newDate}}
        就{{project.projectname}}(项目编号：{{project.projectcode}})采用网上报价方式进行采购。
        现就本次采购的竞价结果公告如下：
      </div>
      <div class="item">
        一、项目编号：{{project.projectcode}}
      </div>
      <div class="item">
        二、项目名称：{{project.projectname}}
      </div>
      <div class="item">
        三、采购预算：人民币{{project.projectlimitamt}}元
      </div>
      <div class="item">
        四、采购时间：{{project.projecttime | newDate}}
      </div>
      <div class="item">
        五、报价汇总表
        <table border="1">
          <tr>
            <td class="border">报价单位</td>
            <td class="border">总报价</td>
            <td class="border">报价时间</td>
            <td class="border">备注</td>
          </tr>
          <!--v-if="psu.psubidflg ===1"-->
          <tr v-for="(psu) in bjhzList" :key="psu.psuid">
            <td align="center">{{psu.comfullname}}</td>
            <td  align="center">{{psu.psuamt}}元</td>
            <td  align="center">{{psu.psutime  | newDate}}</td>
            <td  align="center"></td>
          </tr>
        </table>
      </div>
      <div class="item">
        六、成交信息
        <table  class="resultTab">
          <tr>
            <td class="border">采购内容</td>
            <td class="border">成交单位</td>
            <td class="border">成交金额</td>
            <td class="border">报价时间</td>
          </tr>
          <tr v-for="(psu) in cjxxList" :key="psu.psuid">
            <td align="center">{{project.pmname}}</td>
            <td  align="center">{{psu.comfullname}}</td>
            <td  align="center">{{psu.psuamt}}元</td>
            <td  align="center">{{psu.psutime  | newDate}}</td>
          </tr>
        </table>
      </div>
      <div class="item">
        <div>七、采购人及联系人：	</div>
        <div>采购人：{{project.pcomfullname}}</div>
        <div>联系人：{{project.pusername}}</div>
        <div>联系电话：{{project.projectptel}}</div>
      </div>
      <div class="item" >
        <div>八、采购人及联系人：</div>
        <div>代理人：{{project.comfullname}}</div>
        <div>联系人：{{project.ausername}}</div>
        <div>联系电话：{{project.projectatel}}</div>
      </div>
       <div style="text-align:right">
          <p>发布机构：{{project.comfullname}}</p>
          <p>发布时间：{{project.projectjgfbtime | newDate}}</p>
      </div>
      <div></div>
      <div class="zr">
        <div class="l">责任声明</div>
        <div style="display: block;flex: 1;">本页面提供的内容是由{{project.pcomfullname}}委托{{project.comfullname}}发布的，{{project.comfullname}}对本项目的竞价结果负相关责任且拥有最终解释权。</div>
      </div>
      <div class="line"></div>
      <div class="othergg">
        <div class="item">
          <span>其它公告</span>
          <span style="font-weight: 0;">公告日期</span>
        </div>
        <div class="item"  v-for="(item,index) in project.noticeList" :key="index">
          <span style="font-weight: 0;color: rgb(0, 0, 255)">{{item.noticetitle ? '['+item.noticetitle+']' :'无相关公告'}}</span>
          <span style="font-weight: 0;">{{item.noticetime | newDate}}</span>
        </div>
      </div>
    </div>
  </Container>
</template>
<script>
  import {getLodop} from '@/assets/js/LodopFuncs'
  import utils from '../../assets/js/utils'
  import request from '@/utils/request'
  // import config from '../../assets/config'
  let LODOP
  export default {
    name: 'projectResultNotice',
    props: {
      cproject: {
        type: Object,
        default: function () {
          return {}
        }
      },
      ctype: Number
    },
    filters:{
      newDate(value){
        return utils.formatterDate(value, 'yyyy-MM-dd HH:mm:ss')
      },
    },
    data () {
      return {
        projectid: this.$route.params.projectid,
        type: this.$route.params.type,
        btnLoading: false,
        project: {},
        bjhzList: [],
        cjxxList: []
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getProject()
    },
    // deactivated () {
    //   console.log(this.$data)
    //   Object.assign(this.$data, {})
    // },
    mounted () {
      this.init()
      this.getProject()
    },
    methods: {
      async init() {
        this.projectid = this.cproject.projectid || this.$route.params.projectid
        this.type = this.ctype || this.$route.params.type
        this.btnLoading = false
        this.project = {}
        this.LODOP = null
      },

      async getProject () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectById',
          params: {projectid: this.projectid}
        })
        this.bjhzList = []
        this.cjxxList = []
        res[0].projectlimitamt =  utils.comdify(res[0].projectlimitamt)
        if (res[0].psuList.length) {
          res[0].psuList.forEach(v => {
            v.psuamt = utils.comdify(v.psuamt)
            if(v.psuamt) {
              this.bjhzList.push(v)
            }
            if(+v.psubidflg === 1) {
              this.cjxxList.push(v)
            }
          })
          // res[0].psuList[0].psuamt = utils.comdify(res[0].psuList[0].psuamt)
          // res[0].psuList[1].psuamt = utils.comdify(res[0].psuList[1].psuamt)
        }
        this.project = res[0]
      },

      async fbgg() {
        // let list = await request({
        //   method: 'get',
        //   url: '/xmgl/project/getPsuListByProjectId',
        //   params: {projectid: this.project.projectid, yxflag: 1}
        // })
        // let Index = list.findIndex(item => +item.psubidflg === 1)
        // if (Index ===-1) {
        //   this.$message.warning('未确认成交供应商，不能发布结果公告!')
        //   setTimeout(() => {
        //     this.$router.push({name: 'pbidConfirmForm', params: {form: this.project, type: 1}})
        //   }, 900)
        //   return
        // }
        let data = await request({
          url: '/xmgl/project/projectFbjggg',
          method: "post",
          data: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid,status: '40'}
        })
        if (data.issuccess===1) {
          this.project.projectstatus = '40'
          this.$message.success('结果公告发布成功！')
        } else {
          this.$message.error('结果公告发布失败！')
        }
      },
      close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async lodopPrint () {
        var style = document.createElement('link')
        style.href = 'http://120.78.91.121:9600/upload/20200806/1596702378514.css'
        style.rel = 'stylesheet'
        style.type = 'text/css'
        document.getElementById("px").appendChild(style)
        LODOP = await getLodop()
        if (LODOP) {
          LODOP.SET_PRINT_STYLE("FontSize",10);
          LODOP.ADD_PRINT_HTM(	10, 0, "90%", "80%",document.getElementById("px").innerHTML);
          LODOP.PREVIEW();
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  .status {
    color: red;
    padding-left: 10px;
  }
  .notice-content {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    width: 100%;
    height: 100vh;
    text-align: center;
    overflow: auto;
    font-weight: bold;
    margin-left: 20px;
  }
  .title {
    font-size: 18px;
    color: rgb(255,0,0);
    word-wrap: break-word;
    font-weight: bold;
  }
  .desc {
    color: rgb(255,0,0);
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    margin: 10px 0
  }
  .line, .line1 {
    width: 100%;
    background: rgb(255,0,0);
  }
  .line {
     height: 4px;
     margin-bottom: 4px
  }
  .line1 {
    height: 2px;
  }
  .text {
    padding-left: 2px;
    line-height: 22px;
    text-align: left;
    text-indent: 16px;
    margin-top: 8px
  }
  .item {
    text-align: left;
    margin-top: 8px;
  }
  .zr {
    display: flex;
    align-items:center;
    border-top: 1px solid rgb(192,192,192);
    border-bottom: 1px solid rgb(192,192,192);
    margin-bottom: 4px;
  }
  .zr .l {
    display: block;
    flex: 0 0 180px;
    width: 180px;
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
  }
  .othergg {
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }
  .othergg .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(192,192,192);
    line-height: 28px;
    margin-bottom: 4px
  }
  table{
    border-collapse: collapse;
    margin-top: 10px
  }
  td {
    text-align: center;
  }
  table,table tr td {
    border:1px solid rgb(192,192,192);
  }
  table tr td{
    padding: 5px 10px
  }
</style>
